import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './contact.css'

const Contact = (props) => {
  return (
    <div className="contact-container1">
      <Helmet>
        <title>Contact - Panda Demolition &amp; Disposal</title>
        <meta
          property="og:title"
          content="Contact - Panda Demolition & Disposal"
        />
        <link
          rel="canonical"
          href="https://www.pandademolition.com/contact"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="contact-hero-section">
        <div className="hero-bg-container">
          <video
            src="https://videos.pexels.com/video-files/5594431/5594431-hd_1280_720_25fps.mp4"
            loop="true"
            muted="true"
            poster="https://images.pexels.com/videos/5594431/pictures/preview-0.jpg"
            autoPlay="true"
            playsInline="true"
            className="hero-video contact-hero-video"
          ></video>
          <div className="contact-hero-overlay"></div>
        </div>
        <div className="contact-hero-content-wrapper">
          <div className="hero-card">
            <h1 className="hero-title contact-hero-title">
              Panda Demolition &amp; Disposal
            </h1>
            <p className="hero-subtitle contact-hero-subtitle">
              Industrial-grade demolition and rapid dumpster disposal. One call,
              one solution, zero hassle.
            </p>
            <div className="hero-phone-block">
              <div className="hero-icon-wrap">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <a href="tel:+19544081674">
                <div className="hero-phone-link">
                  <span>(954) 408-1674</span>
                </div>
              </a>
            </div>
            <div className="contact-hero-actions">
              <button onClick={() => window.openIframeModal('https://app.icans.ai/customer-portal/panda-demolition/book/')} className="navigation-btn-reset">
                <div className="btn btn-xl btn-secondary">
                  <span>Book a Dumpster</span>
                </div>
              </button>
              <a href="#rfq-form">
                <div className="btn-outline btn btn-xl">
                  <span>Request RFQ Project</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section id="order-form" className="form-section">
        <div className="form-container">
          <div className="form-header">
            <h2 className="section-title">Get Started Today</h2>
            <p className="section-subtitle">
              Toggle between quick dumpster rental or a full project RFQ.
            </p>
          </div>
          <div className="form-tabs-container">
            <div className="form-tabs-row">
              <button id="tab-dumpster" className="form-tab active">
                Dumpster Order
              </button>
              <button id="tab-rfq" className="form-tab">
                Submit RFQ
              </button>
            </div>
            <div className="form-content-area">
              <form
                id="dumpster-form"
                className="active contact-form"
              >
                <div className="form-grid">
                  <div className="form-group">
                    <label className="form-label">Full Name</label>
                    <input type="text" name="name" required placeholder="John Doe" className="form-input" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Phone Number</label>
                    <input type="tel" name="phone" required placeholder="(555) 000-0000" className="form-input" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Dumpster Size</label>
                    <select name="size" required className="form-input">
                      <option value="">Select Size</option>
                      <option value="10">10 Yard - Residential</option>
                      <option value="20">20 Yard - Mid-Size</option>
                      <option value="30">30 Yard - Large Project</option>
                      <option value="40">40 Yard - Industrial</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Delivery Date</label>
                    <input type="date" name="date" required className="form-input" />
                  </div>
                  <div className="form-group full-width">
                    <label className="form-label">Drop-off Address</label>
                    <input type="text" name="address" required placeholder="123 Main St, City, FL" className="form-input" />
                  </div>
                </div>
                <button type="submit" className="btn-lg btn form-submit btn-secondary">
                  Order Instant Pickup
                </button>
                <p className="form-status" style={{textAlign: 'center', marginTop: '8px', display: 'none'}}></p>
              </form>
              <form
                id="rfq-form"
                className="contact-thq-contact-form-elm2 contact-form"
              >
                <div className="form-grid">
                  <div className="form-group">
                    <label className="form-label">Company Name</label>
                    <input type="text" name="company" required placeholder="Panda Construction" className="form-input" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Email Address</label>
                    <input type="email" name="email" required placeholder="email@example.com" className="form-input" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Project Type</label>
                    <select name="project_type" required className="form-input">
                      <option value="">Select Project</option>
                      <option value="full-demo">Full Demolition</option>
                      <option value="selective-demo">Commercial Remodel</option>
                      <option value="site-clearing">Site Clearing</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Phone Number</label>
                    <input type="tel" name="phone" placeholder="(555) 000-0000" className="form-input" />
                  </div>
                  <div className="form-group full-width">
                    <label className="form-label">Project Details</label>
                    <textarea name="details" rows="4" placeholder="Describe the scope of work..." className="form-input"></textarea>
                  </div>
                </div>
                <button type="submit" className="btn-primary btn-lg btn form-submit">
                  Submit RFQ for Review
                </button>
                <p className="form-status" style={{textAlign: 'center', marginTop: '8px', display: 'none'}}></p>
              </form>
            </div>
          </div>
        </div>
      </section>
      <section className="contact-features-section">
        <div className="features-container">
          <div className="contact-features-grid">
            <div className="contact-feature-card">
              <div className="feature-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092a10 10 0 1 0-4.777-4.719"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Live Support Chat</h3>
              <p className="section-content">
                Connect with our dispatch team instantly. Average response time:
                2 minutes.
              </p>
              <span className="feature-tag">Online Now</span>
            </div>
            <div className="contact-feature-card">
              <div className="feature-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2m10 0H9m10 0h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>
                    <circle r="2" cx="17" cy="18"></circle>
                    <circle r="2" cx="7" cy="18"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Emergency Pickup</h3>
              <p className="section-content">
                Overloaded site? We offer same-day emergency swap-outs for
                active projects.
              </p>
              <span className="feature-tag">24/7 Priority</span>
            </div>
            <div className="contact-feature-card">
              <div className="feature-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 6v6l4 2"></path>
                    <circle r="10" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Flexible Scheduling</h3>
              <p className="section-content">
                Pre-schedule your entire project timeline or call for recurring
                disposal cycles.
              </p>
              <span className="feature-tag">Custom Plans</span>
            </div>
            <div className="contact-feature-card">
              <div className="feature-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Rapid Estimates</h3>
              <p className="section-content">
                Receive detailed RFQ breakdowns within 24 hours of plan
                submission.
              </p>
              <span className="feature-tag">&lt; 24hr Turnaround</span>
            </div>
          </div>
        </div>
      </section>
      <section className="contact-location-section">
        <div className="contact-location-split">
          <div className="contact-location-info">
            <h2 className="section-title">Visit Our Headquarters</h2>
            <p className="section-subtitle">
              Based in the heart of the industrial district.
            </p>
            <div className="location-details">
              <div className="location-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                    <circle r="3" cx="12" cy="10"></circle>
                  </g>
                </svg>
                <div>
                  <strong>Main Office</strong>
                  <p>888 Demolition Drive, Steel City, SC 29000</p>
                </div>
              </div>
              <div className="location-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 6v6l4 2"></path>
                    <circle r="10" cx="12" cy="12"></circle>
                  </g>
                </svg>
                <div>
                  <strong>Operational Hours</strong>
                  <p>
                    <span>Mon - Fri: 6:00 AM - 8:00 PM</span>
                    <br></br>
                  </p>
                </div>
              </div>
              <div className="location-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M5 17a2 2 0 1 0 4 0a2 2 0 1 0-4 0m10 0a2 2 0 1 0 4 0a2 2 0 1 0-4 0"></path>
                    <path d="M5 17H3v-4M2 5h11v12m-4 0h6m4 0h2v-6h-8m0-5h5l3 5M3 9h4"></path>
                  </g>
                </svg>
                <div>
                  <strong>Service Coverage</strong>
                  <p>
                    Full-service demolition &amp; disposal across the tri-state
                    area.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="location-map-container">
            <img
              alt="Service Map Area"
              src="https://images.pexels.com/photos/12372902/pexels-photo-12372902.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="location-map-img"
            />
            <div className="contact-map-marker">
              <svg
                width="32"
                xmlns="http://www.w3.org/2000/svg"
                height="32"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="var(--color-secondary)"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                  <circle r="3" cx="12" cy="10"></circle>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </section>
      <section className="contact-process-section">
        <div className="contact-process-container">
          <h2 className="section-title">How It Works</h2>
          <div className="contact-process-steps">
            <div className="process-step">
              <div className="contact-step-number">
                <span>01</span>
              </div>
              <div className="step-content">
                <h3 className="section-subtitle">Submit Inquiry</h3>
                <p className="section-content">
                  Fill out our quick form or call (954) 408-1674 to specify
                  your needs.
                </p>
              </div>
            </div>
            <div className="process-step">
              <div className="contact-step-number">
                <span>02</span>
              </div>
              <div className="step-content">
                <h3 className="section-subtitle">Confirm Details</h3>
                <p className="section-content">
                  Our team reviews your site or RFQ plans and confirms pricing
                  within hours.
                </p>
              </div>
            </div>
            <div className="process-step">
              <div className="contact-step-number">
                <span>03</span>
              </div>
              <div className="step-content">
                <h3 className="section-subtitle">Deliver &amp; Pickup</h3>
                <p className="section-content">
                  We deploy equipment or dumpsters to your site. Fast, reliable,
                  and on-time.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="contact-testimonials-section">
        <div className="contact-testimonials-rail">
          <div className="contact-testimonial-card">
            <div className="testimonial-stars">
              <svg
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                  fill="currentColor"
                ></path>
              </svg>
            </div>
            <p className="testimonial-text">
              &quot;Fastest dumpster turnaround I&apos;ve seen in 15 years of
              contracting. Panda is our go-to for every site.&quot;
            </p>
            <div className="contact-testimonial-author">
              <strong>Mike R.</strong>
              <span>Project Manager, Urban Build Co.</span>
            </div>
          </div>
          <div className="contact-testimonial-card">
            <div className="testimonial-stars">
              <svg
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                  fill="currentColor"
                ></path>
              </svg>
            </div>
            <p className="testimonial-text">
              &quot;Panda&apos;s RFQ process is seamless. Uploaded our
              blueprints and had a competitive bid by the next morning.&quot;
            </p>
            <div className="contact-testimonial-author">
              <strong>Sarah L.</strong>
              <span>Operations, Demolition Experts Inc.</span>
            </div>
          </div>
          <div className="contact-testimonial-card">
            <div className="testimonial-stars">
              <svg
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                  fill="currentColor"
                ></path>
              </svg>
            </div>
            <p className="testimonial-text">
              &quot;Reliable, honest, and the equipment is always in top
              condition. Best disposal partner in the city.&quot;
            </p>
            <div className="contact-testimonial-author">
              <strong>John D.</strong>
              <span>Owner, JD Heavy Excavation</span>
            </div>
          </div>
        </div>
      </section>
      <section className="contact-cta-section">
        <div className="cta-trigger-container">
          <h2 className="section-title">Ready to Clear the Way?</h2>
          <p className="section-content">
            Call us directly or use our smart inquiry tool to get priority
            service today.
          </p>
          <button id="open-cta-modal" className="btn btn-xl btn-secondary">
            Contact Panda Now
          </button>
        </div>
        <dialog id="cta-modal" className="cta-dialog">
          <div className="cta-modal-content">
            <h2 className="hero-title contact-hero-title">Priority Support</h2>
            <p className="section-content">
              Choose your preferred way to connect with the Panda team.
            </p>
            <div className="cta-options">
              <a href="tel:+19544081674">
                <div className="cta-option-card">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Call Dispatch</span>
                  <strong>(954) 408-1674</strong>
                </div>
              </a>
              <a href="#order-form" id="modal-order-btn">
                <div className="cta-option-card">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2m10 0H9m10 0h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>
                      <circle r="2" cx="17" cy="18"></circle>
                      <circle r="2" cx="7" cy="18"></circle>
                    </g>
                  </svg>
                  <span>Order Online</span>
                  <strong>Instant Dumpster</strong>
                </div>
              </a>
            </div>
            <button id="close-cta-modal" className="btn-outline btn btn-sm">
              Close Window
            </button>
          </div>
        </dialog>
      </section>
      <div className="contact-container5">
        <div className="contact-container6">
          <Script
            html={`<style>
        @keyframes markerPulse {0%,100% {transform: translate(-50%, -100%) scale(1);}
50% {transform: translate(-50%, -115%) scale(1.1);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="contact-container7">
        <div className="contact-container8">
          <Script
            html={`<script defer data-name="panda-demo-scripts">
(function(){
  // Tab Switching Logic
  const dumpsterTab = document.getElementById('tab-dumpster');
  const rfqTab = document.getElementById('tab-rfq');
  const dumpsterForm = document.getElementById('dumpster-form');
  const rfqForm = document.getElementById('rfq-form');

  dumpsterTab.addEventListener('click', () => {
    dumpsterTab.classList.add('active');
    rfqTab.classList.remove('active');
    dumpsterForm.style.display = 'block';
    rfqForm.style.display = 'none';
  });

  rfqTab.addEventListener('click', () => {
    rfqTab.classList.add('active');
    dumpsterTab.classList.remove('active');
    rfqForm.style.display = 'block';
    dumpsterForm.style.display = 'none';
  });

  // Modal Logic
  const modal = document.getElementById('cta-modal');
  const openBtn = document.getElementById('open-cta-modal');
  const closeBtn = document.getElementById('close-cta-modal');
  const modalOrderBtn = document.getElementById('modal-order-btn');

  openBtn.addEventListener('click', () => {
    modal.showModal();
  });

  closeBtn.addEventListener('click', () => {
    modal.close();
  });

  modalOrderBtn.addEventListener('click', () => {
    modal.close();
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.close();
    }
  });

  // Form submissions via Resend API
  async function handleFormSubmit(form, endpoint, successMsg) {
    const btn = form.querySelector('.form-submit');
    const status = form.querySelector('.form-status');
    const originalText = btn.textContent;
    btn.textContent = 'Sending...';
    btn.disabled = true;
    if (status) status.style.display = 'none';

    const formData = new FormData(form);
    try {
      const resp = await fetch('' + endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.fromEntries(formData)),
      });
      const result = await resp.json();
      if (result.success) {
        if (status) {
          status.textContent = successMsg;
          status.style.color = '#16a34a';
          status.style.display = 'block';
        }
        form.reset();
      } else {
        throw new Error(result.error);
      }
    } catch (err) {
      if (status) {
        status.textContent = 'Something went wrong. Please call us at (954) 408-1674.';
        status.style.color = '#dc2626';
        status.style.display = 'block';
      }
    }
    btn.textContent = originalText;
    btn.disabled = false;
  }

  const dumpsterFormEl = document.getElementById('dumpster-form');
  if (dumpsterFormEl) {
    dumpsterFormEl.addEventListener('submit', (e) => {
      e.preventDefault();
      handleFormSubmit(dumpsterFormEl, '/api/dumpster-order', '\\u2713 Order submitted! We\\'ll confirm delivery shortly.');
    });
  }

  const rfqFormEl = document.getElementById('rfq-form');
  if (rfqFormEl) {
    rfqFormEl.addEventListener('submit', (e) => {
      e.preventDefault();
      handleFormSubmit(rfqFormEl, '/api/rfq', '\\u2713 RFQ submitted! We\\'ll send your quote within 24-48 hours.');
    });
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Contact
